import { useTranslation } from "../i18n";
import WriteOff from "./write-off";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

// Admin › Warehouse › Write Off — the module's only entry point (admin
// header + breadcrumbs here; the page itself has no scanner chrome).
const AdminWriteOff = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="write_off"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "write_off" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("warehouse_tile_write_off_desc")}</p>
                <WriteOff />
            </div>
        </div>
    );
};

export default AdminWriteOff;
